import HeroSection from "@/components/landing/HeroSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import WhyDifferentSection from "@/components/landing/WhyDifferentSection";
import AppWaitlistSection from "@/components/landing/AppWaitlistSection";
import FooterSection from "@/components/landing/FooterSection";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      {/* Full-page chequered flag pattern */}
      <div
        className="pointer-events-none fixed inset-0 z-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(45deg, hsl(var(--foreground)) 25%, transparent 25%), linear-gradient(-45deg, hsl(var(--foreground)) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, hsl(var(--foreground)) 75%), linear-gradient(-45deg, transparent 75%, hsl(var(--foreground)) 75%)",
          backgroundSize: "24px 24px",
          backgroundPosition: "0 0, 0 12px, 12px -12px, -12px 0",
        }}
      />

      <HeroSection />
      <SocialProofSection />
      <HowItWorksSection />
      <WhyDifferentSection />
      <AppWaitlistSection />
      <FooterSection />
    </div>
  );
}
